module.exports = {
      id: "comments-outline-usage",
      viewBox: "0 0 32 36",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#comments-outline",
      toString: function () {
        return this.url;
      }
    }